import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface AnimatedCounterProps {
  end: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
}
function AnimatedCounter({
  end,
  suffix = '',
  prefix = '',
  duration = 2
}: AnimatedCounterProps) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, {
    once: true
  });
  useEffect(() => {
    if (!isInView) return;
    let startTime: number;
    let animationFrame: number;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(easeOutQuart * end));
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isInView, end, duration]);
  return <span ref={ref} data-id="element-186">
      {prefix}
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export function StatsBar() {
  const stats = [{
    value: 25,
    prefix: '+',
    suffix: 'K',
    label: 'Diseños incluidos'
  }, {
    value: 26,
    prefix: '',
    suffix: '',
    label: 'Carpetas organizadas'
  }, {
    value: 1,
    prefix: '+',
    suffix: 'K',
    label: 'Diseños por carpeta'
  }, {
    value: null,
    symbol: '∞',
    label: 'Ventas permitidas'
  }];
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-gradient-to-r from-rose-500 via-pink-500 to-rose-500 py-8 sm:py-12" data-id="element-187">
      <div ref={containerRef} className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-189">
          {stats.map((stat, index) => <motion.div key={stat.label} className="text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-190">
              <div className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-1" data-id="element-191">
                {stat.symbol ? stat.symbol : <AnimatedCounter end={stat.value!} prefix={stat.prefix} suffix={stat.suffix} data-id="element-192" />}
              </div>
              <div className="text-rose-100 text-sm sm:text-base font-medium" data-id="element-193">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}